import React from "react";

// Small status strip above the QR Scan Log. `status` = GET /api/qr-purchase/status
// ({ busyWeighbridges, recentWindowMinutes }); null while loading or on error.
export function QrScanStatusStrip({status, statusError, lastRefreshed}) {
    const windowMinutes = status?.recentWindowMinutes || 20;
    const busyCount = Array.isArray(status?.busyWeighbridges) ? status.busyWeighbridges.length : 0;

    return (
        <div className="mb-4">
            {statusError && (
                <div className="alert alert-danger py-2 mb-3">
                    <small>Could not read the QR scanner status. Retrying…</small>
                </div>
            )}
            <div className="d-flex flex-wrap align-items-center gap-4 text-muted fs-7">
                <span>
                    <i className="bi bi-arrow-repeat me-1"></i>
                    Repeat scans of the same vehicle within {windowMinutes} minutes are ignored
                </span>
                {busyCount > 0 && (
                    <span className="badge badge-light-info">
                        Weighing in progress on {busyCount} weighbridge{busyCount > 1 ? "s" : ""}
                    </span>
                )}
                {lastRefreshed && (
                    <span className="ms-auto">
                        Auto-refreshes every 10 seconds · last updated {lastRefreshed.toLocaleTimeString()}
                    </span>
                )}
            </div>
        </div>
    );
}
